﻿import $ from "jquery";
import "select2";
import { Toast, Tooltip } from "bootstrap";

import { IToast } from "./Interface/IToast";
import { IQuickSearchResultElement } from "./Interface/IQuickSearchResultElement";
import { AppLog } from "./AppLog";

export class GuiBase {
    helpOn: boolean;
    source: string;
    form: HTMLFormElement;
    secondsLeft: number;
    intervallLogout?: number;
    searchTimer: number;

    constructor(source: string) {
        this.source = source;
        this.log(`GuiBase: ${source}`);
        this.form = $("#detailForm")[0] as HTMLFormElement;

        this.attachEvents();
        this.helpOn = false;

        $(".select2").select2({
            theme: "bootstrap-5",
        });

        $("select.tags").select2({
            tokenSeparators: [",", " "]
        });

        this.showToastsHidden();

        // Wechsel auf den gewünschten Tab
        const tab = $("input#CurrentTab").val() as string;
        this.changeToTab(tab);

        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"][data-bs-title]')
        ;[...tooltipTriggerList]
            .filter(el => el.getAttribute('data-bs-title') !== '')
            .map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))

        this.startLogoutTimer();

        this.createQuickSearch();

        $("select.select2.tags").select2({
            tags: true,
            allowClear: true,
            placeholder: "",
            theme: "bootstrap-5"
        });

        $(".dofocus").focus();

        this.secondsLeft = 60*55; // 55 Minuten
        this.searchTimer = 0;
    }

    protected changeToTab(tab: string) {
        this.log(`changeToTab = ${tab}`);

        if (tab != undefined && tab !== "") {
            $("ul.nav.nav-tabs li.nav-item button").removeClass("active");
            const btn = $(`ul.nav.nav-tabs li.nav-item button[data-bs-target='${tab}']`);
            btn.addClass("active");
            $("div.tab-pane").removeClass("active show");
            $(`div${tab}`).addClass("show active");
        } else {
            this.log("Error: Tab nicht gefunden");
        }
    }

    

    protected attachEvents() {
        this.log("GuiBase.attachEvents");

        $(document).keydown(e => {
            if (e.keyCode === 27) {
                e.preventDefault();
                this.log("ESC --> Back");
                const ele = $("#btnBarBack")[0];
                if (ele != undefined) ele.click();
                return;
            }
        });

        $("span.erz-pwd-toggle").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickPwdToggle(e));
        
        $("button.erzlock").on("click", (e:JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => {
            const spinner = $("<span class='spinner-grow spinner-grow-sm' role='status'></span>");
            $(e.currentTarget).append(spinner);
            this.lock();
        });

        $("button.btn-date-remove").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => {
            AppLog.logInfo("click remove date");
            $(e.currentTarget).closest("div.input-group").find("input").val("").trigger("change");
        });

        $("#btnQuickSearch").on("click", () => this.clickSearch());

        $("#spanGetEanvConfig").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => {this.clickShowEanvConfig(e)});
    }

    //#region Toasts

    protected showToastsHidden() {
        const value = $("#toasts").val();
        this.log(value as string);
        if (typeof value !== "string" || value.trim() === "") return;

        const toasts = JSON.parse(value) as IToast[];

        $("#toasts").val("[]");
        this.showToasts(toasts);
    }

    

    protected showToasts(toasts: Array<IToast>) {
        this.log("showToasts");
        $("#toaststack").empty();

        if (toasts == null || toasts.length === 0) return;

        toasts.forEach((toast) => {
            this.createToast(toast);
        });

        const toastElList = [].slice.call(document.querySelectorAll("div.toast"));
        toastElList.map((toastEl: never) => {
            const myToast = Toast.getOrCreateInstance(toastEl); 
            myToast.show();
        });
        
    }

    protected createToast(toast: IToast) {
        this.log(`createToast: level=[${toast.level}] msg=[${toast.message}]`);

        const now = new Date();
        const pad = (n: number) => String(n).padStart(2, '0');
        const datum = `${pad(now.getDate())}.${pad(now.getMonth() + 1)}.${now.getFullYear()} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
        const id = `toast-${Date.now()}`;
        let levelClass = "bg-primary";
        switch (toast.level.toLowerCase()) {
            case "error":
            case "danger":
                levelClass = "bg-danger";
                toast.duration = 20000;
                break;
            case "warning":
                levelClass = "bg-warning";
                break;
            case "info":
                levelClass = "bg-success";
                break;
            default:
        }
        if (toast.title == undefined) {
            toast.title = "";
        }
        // 
        const fmtToast = `
            <div id="liveToast-${id}" class="toast text-white ${levelClass}" role="alert" data-bs-autohide="true" data-bs-delay="${toast.duration}" > 
                <div class="toast-header" >
                    <i class="fa fa-info-circle me-2" > </i> <strong class="me-auto">${toast.title}</strong>
                    <small>${datum}</small>
                    <button type="button" class="btn-close" data-bs-dismiss="toast"> </button>
                </div>
                <div class="toast-body" >${toast.message}</div>
            </div>`;
        $(fmtToast).appendTo($("#toaststack"));
    }

    createToastValidate(t:string, m: string, l: string, d: number) {

        const toast = {} as IToast;

        toast.duration = d;
        toast.message = m;
        toast.level = l;
        toast.title = t;

        this.showToasts([toast]);
    }

    protected gotoUrl(url: string) {
        this.log(`url=[${url}]`);
        if (url == undefined) return;
        this.lock();
        document.location.href = url;

    }

    protected displayToast(toast: IToast) {
        $("div.toast").remove();
        this.createToast(toast);
        const toastElList = [].slice.call(document.querySelectorAll("div.toast"));
        toastElList.map((toastEl: never) => {
            const myToast = Toast.getOrCreateInstance(toastEl); // 
            myToast.show();
        });
    }

    //#endregion

    protected lock() {
        $("#screenblock").removeClass("d-none");
    }

    protected unlock() {
        $("#screenblock").addClass("d-none");
    }

    protected clickShowEanvConfig(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickShowEanvConfig");
        e.preventDefault();
        
        const el = document.getElementById("'mdlEanvConfig");
        if(el) {el.remove();}

       const url = $("#spanGetEanvConfig").data("url");
       this.log(url);
        $.get(url, (data) => {
            $("body").append($(data));
            $("#mdlEanvConfig").modal("show");
        });
    }

    protected clickPwdToggle(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickPwdToggle");

        const erzPwdToggle = $(e.currentTarget);
        const show_eye = erzPwdToggle.find(".fa-eye");
        const hide_eye = erzPwdToggle.find(".fa-eye-slash");
        const input = erzPwdToggle.closest("div.input-group").find(".form-control")[0] as HTMLInputElement;

        if (input.type === "password") {
            input.type = "text";
            hide_eye.removeClass("d-none");
            show_eye.addClass("d-none");
            
        } else {
            input.type = "password";
            hide_eye.addClass("d-none");
            show_eye.removeClass("d-none");
        }

    }

    protected createSpinner(element: JQuery) {
        const spinner = $("<span class='spinner-grow spinner-grow-sm' role='status'></span>");
        element.prepend(spinner);
    }

    log(msg: string) {
        AppLog.logInfo(this.source, msg);
    }

    //protected doAction(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
    //    const guiAktion = $(e.currentTarget).data("guiaktion");
    //    this.log(`doAction: ${guiAktion}`);
    //    $("#GuiAktion").val(guiAktion);

    //    if (!this.form.checkValidity()) {

    //        e.stopPropagation();
    //        return;
    //    } else {
    //        this.lock();
    //        // Submit form über Browser Button
    //    }
    //}

    protected doAction(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        const guiAktion = $(e.currentTarget).data("guiaktion");
        this.log(`doAction: ${guiAktion}`);
        $("#GuiAktion").val(guiAktion);

        // Save Tab
        const tab = $("ul.nav.nav-tabs li.nav-item button.active").data("bs-target");
        $("input#CurrentTab").val(tab);

        if (!this.form.checkValidity()) {

            e.stopPropagation();
            return;
        } else {
            this.lock();
            // Submit form über Browser Button
            e.stopPropagation();
            this.form.submit()
        //   var btn = $(e.currentTarget);
        //   if(btn.is('button[type="button"]')) this.form.submit();
        }
    }


    //#region ## Logout Timer ###

    protected startLogoutTimer() {
        this.log("startLogoutTimer");
        this.secondsLeft = 60*55; // 55 Minuten
        this.showLogout();
        this.intervallLogout = window.setInterval(() => this.updateTimer(),1000);
    }

    private updateTimer() {
        this.secondsLeft--;

        if (this.secondsLeft <= 0) {
            this.log("automatic logout");
            const logoutUrl = $("#spanLogoutTimer").data("logouturl");
            this.gotoUrl(logoutUrl);
        }

        if (this.secondsLeft === 60) {
            const toast: IToast = {
                title:"Logout", message:"Automatischer Logout steht bevor", duration:8000, level:"error"
            };
            $("#spanLogoutTimer").addClass("text-danger");
            this.displayToast(toast);
        }

        this.showLogout();
    }

    private showLogout() {
        const sec = String(this.secondsLeft % 60).padStart(2, '0');
        const min = Math.floor(this.secondsLeft / 60);
        const fmt = `${min}:${sec}`;
        $("#spanLogoutTimer").text(fmt);
    }


    //#endregion

    clickSearch() {
        this.log("clickSearch");
        this.runQuickSearch();
    }

    runQuickSearch() {
        this.doSearch();
    }


    //#region Autocomplete 


    createQuickSearch() {

        $("#txtQuickSearch").on("input", () => this.inputQuickSearch());
        $("#txtQuickSearch").on("keydown", (e:JQuery.TriggeredEvent) => this.inputQuicksearchNav(e));

        $("body").on("click", () => { this.closeAllLists(); });
    }

    inputQuicksearchNav(e:JQuery.TriggeredEvent) {
        console.log("inputQuicksearchNav");
        if (e.keyCode === 40) {
            this.nextActive();
        } else if (e.keyCode === 38) { //up
            this.backActive();
        } else if (e.keyCode === 13) {
            console.log("Quicksearch enter");
            e.preventDefault();

            const alle = $(".autocomplete-item");
            if (alle.length === 1) {
                const url = alle.first().data("id");
                this.gotoUrl(url);
            }
            const active = alle.filter(".autocomplete-active");
            if (active.length !== 0) {
                const url = active.data("id");
                this.gotoUrl(url);
            }


        }
    }

    nextActive() {
        console.log("nextActive");
        const alle = $(".autocomplete-item");
        const active = alle.filter(".autocomplete-active");
        const next = active.next(".autocomplete-item");
        alle.removeClass("autocomplete-active");
        if (next.length > 0) {
            next.addClass("autocomplete-active");
        } else {
            alle.first().addClass("autocomplete-active");
        }

    }

    backActive() {
        console.log("backActive");

        const alle = $(".autocomplete-item");
        const active = alle.filter(".autocomplete-active");
        const next = active.prev(".autocomplete-item");
        alle.removeClass("autocomplete-active");
        if (next.length > 0) {
            next.addClass("autocomplete-active");
        } else {
            alle.last().addClass("autocomplete-active");
        }
    }

    inputQuickSearch() {
        console.log("inputQuickSearch");

        const inp = $("#txtQuickSearch");
        const val = inp.val() as string;
        this.closeAllLists();
        if (!val) { return; }
        if (val.length === 0) {
            this.closeAllLists();
            return;
        }

        window.clearTimeout(this.searchTimer);

        this.searchTimer = window.setTimeout(() => {
            window.clearTimeout(this.searchTimer);
            this.doSearch();
        }, 300);
    }

    doSearch() {
        console.log("inputQuickSearch");

        const inp = $("#txtQuickSearch");
        const val = inp.val() as string;
        const url = inp.data("url") + "?v=" + val;


        const quickSearch =  { "Term": val } ;
        //var quickSearch = { quickSearch: { "Term": val } };

        const json = JSON.stringify(quickSearch);

        $.ajax({
            url: url,
            type: "POST",
            data: json,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: (ans) => {
                const values = ans as IQuickSearchResultElement[];

                    const a = $("<div>");
                    a.attr("id", inp[0].id + "autocomplete-list");
                    a.attr("class", "autocomplete-items");
                    inp.parent().append(a);

                    const val = inp.val() as string;
                    if (val.length === 0) {
                        this.closeAllLists();
                        return;
                    }

                    console.log(values.length);

                    for (let i = 0; i < values.length; i++) {
                        const v = values[i];
                        const item = $("<div>");
                        item.addClass("autocomplete-item");

                        const img = `<img src='/img/icons/${v.icon}'>`;
                        const text = `<span>${v.text}</span>`;
                        const row = $("<div class='row' style='' title='" + v.typ + "'><div class='col-2'>" + img + "</div><div class='col-10'>" + text + "</div></div>");
                        item.append(row);
                        //item.append(text);
                        
                        item.data("url", v.link);
                        item.on("click", (e:JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickQuickSearchElement(e));
                        a.append(item);
                    }
            }
        });

        

    }


    closeAllLists() {
        $("div.autocomplete-items").remove();
    }


    clickQuickSearchElement(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        const url = $(e.currentTarget).data("url");
        this.gotoUrl(url);
    }

    //#endregion

}